import { jsx } from "react/jsx-runtime";
import InboxIcon from "@mui/icons-material/Inbox";
import { validateTidalLicense } from "../../base/index.js";
function Inbox(props) {
  return /* @__PURE__ */ jsx(
    InboxIcon,
    {
      "data-testid": "Inbox",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Inbox",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
Inbox.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "Inbox"
};
validateTidalLicense();
export {
  Inbox
};
//# sourceMappingURL=Inbox.js.map
